import Alentoor from '../../vendor/Alentoor';

// Vendor
Alentoor.init();
